import React from 'react';
import { LoadingIndicator } from 'lib/components';
import { Flex } from 'lib/components/styles/layout';
import {
  EmptySearchText,
  EmptySearchWrapper,
} from 'app/pages/admin/landing-pages-v2/styles';
import { IHighlight } from 'lib/api/highlights/useQueryHighlights';
import { PaginationConstants } from 'lib/const/PaginationConstants';
import { Button } from 'react-covideo-common';
import { MdAdd } from 'react-icons/md';
import { useTheme } from 'styled-components/macro';
import { HighlightTable } from './HighlightTable';
import { HIGHLIGHTS_SORT_KEYS } from '../constants';

interface IHighlightListProps {
  data: IHighlight[];
  isLoadingHighlights?: boolean;
  count: number;
  page: number;
  size: number;
  sortKey: HIGHLIGHTS_SORT_KEYS | null;
  order: PaginationConstants;
  onPaginationChange: (args: { page: number; size: number }) => void;
  onSortingUpdate: (sortKey: string, order: PaginationConstants) => void;
  handleEditClick: (highlight: IHighlight) => void;
  handleCreateClick: () => void;
}

export const HighlightList = ({
  data,
  isLoadingHighlights,
  count,
  page,
  size,
  sortKey,
  order,
  onPaginationChange,
  onSortingUpdate,
  handleEditClick,
  handleCreateClick,
}: IHighlightListProps) => {
  const theme = useTheme();

  return (
    <>
      <Flex
        width='100%'
        flexDirection='row'
        gap='27px'
        justifyContent='flex-start'
        flexWrap='wrap'
      >
        {isLoadingHighlights ? (
          <Flex width='100%' justifyContent='center'>
            <LoadingIndicator isLoading={true} />
          </Flex>
        ) : (
          <>
            {data && data.length > 0 ? (
              <HighlightTable
                count={count}
                data={data}
                page={page}
                size={size}
                sortKey={sortKey}
                order={order}
                onPaginationChange={onPaginationChange}
                onSortingUpdate={onSortingUpdate}
                handleEditClick={handleEditClick}
              />
            ) : (
              <EmptySearchWrapper>
                <EmptySearchText maxWidth='677px' fontSize='16px'>
                  No dealership highlights added yet. Add a highlight you’d like
                  AI to use when creating scripts and videos.
                </EmptySearchText>
                <Button
                  text='Add Highlight'
                  icon={<MdAdd color={theme.colors.white[100]} />}
                  onClick={handleCreateClick}
                />
              </EmptySearchWrapper>
            )}
          </>
        )}
      </Flex>
    </>
  );
};
